import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "id", "size", "testID", "UNSAFE_svgProps"];
import React from 'react';
import Surface from '@bubble-ui/primitive-surface';
import Shape from '@bubble-ui/primitive-shape';
import Defs from '@bubble-ui/primitive-defs';
import LinearGradient from '@bubble-ui/primitive-linear-gradient';
import Stop from '@bubble-ui/primitive-stop';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
var ColoredIllustrationErrorUFO = _ref => {
  var {
      accessibilityLabel,
      id,
      size = 100,
      testID,
      UNSAFE_svgProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'ColoredIllustrationErrorUFO',
    props,
    useInstead: 'UNSAFE_svgProps',
    removalDate: 'v7.0.0'
  });
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    accessibilityLabel: accessibilityLabel,
    fill: "none",
    viewBox: "0 0 100 100",
    width: size,
    height: size
  }, props), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint0_linear_21134_70419)",
    fillRule: "evenodd",
    d: "m36.65 52-22 30s4 13.48 35 13c31-.48 35-14 35-14l-23-30-25 1Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#6566D1",
    fillRule: "evenodd",
    d: "M99.65 45c0 10.49-22.16 19-49.5 19S.65 55.49.65 45c0-3.79-.98-8.04 4-11 8.81-5.24 28.04-8 45.5-8 18.79 0 38.12 3.08 46.5 9 3.81 2.69 3 6.72 3 10Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint1_linear_21134_70419)",
    d: "M50.15 59c27.338 0 49.5-8.507 49.5-19s-22.162-19-49.5-19S.65 29.507.65 40s22.162 19 49.5 19Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint2_linear_21134_70419)",
    fillRule: "evenodd",
    d: "M23.24 31.54S22.43 7.5 48.54 7.5s27.52 24.04 27.52 24.04-.41 9.46-27.86 9.49c-24.55.03-24.96-9.49-24.96-9.49Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#6566D1",
    fillRule: "evenodd",
    d: "M46.06 51.27S45.95 48 49.5 48s3.74 3.27 3.74 3.27-.06 1.28-3.78 1.29c-3.34 0-3.4-1.29-3.4-1.29ZM11.16 42.55s-.11-3.27 3.44-3.27 3.74 3.27 3.74 3.27-.06 1.28-3.78 1.29c-3.34 0-3.4-1.29-3.4-1.29ZM77.16 42.55s-.11-3.27 3.44-3.27 3.74 3.27 3.74 3.27-.06 1.28-3.78 1.29c-3.34 0-3.4-1.29-3.4-1.29Z"
  }), /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint0_linear_21134_70419",
    x1: 49.875,
    x2: 49.295,
    y1: 95.605,
    y2: 59.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0.249,
    stopColor: "#F3DCA6"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#F1B6C5"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint1_linear_21134_70419",
    x1: 1.183,
    x2: 118.617,
    y1: 43.612,
    y2: 34.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#907CE7"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.491,
    stopColor: "#04C9DD"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.992,
    stopColor: "#CDFAE4"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint2_linear_21134_70419",
    x1: 62.913,
    x2: 34.877,
    y1: 11.946,
    y2: 44.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#D5D8FF"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.004,
    stopColor: "#D2D6FE"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.061,
    stopColor: "#B3B9F7"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.125,
    stopColor: "#98A1F0"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.198,
    stopColor: "#828EEB"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.283,
    stopColor: "#717EE7"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.388,
    stopColor: "#6674E4"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.536,
    stopColor: "#5F6EE2"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.946,
    stopColor: "#5D6CE2"
  }))));
};
ColoredIllustrationErrorUFO.displayName = 'ColoredIllustrationErrorUFO';
export default withProvisionalOverrideFromContext(ColoredIllustrationErrorUFO);
//# sourceMappingURL=index.js.map